var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-app-bar',{attrs:{"dark":"","flat":"","max-height":"65"}},[_c('Navbar')],1),_c('div',{staticClass:"appBody"},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }